// extracted by mini-css-extract-plugin
module.exports = {"active":"Button-module--active--1Wm03","inactive":"Button-module--inactive--yhMXW"};